// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { DnsRrTypeSchema } from '../inputTypeSchemas/DnsRrTypeSchema'

/////////////////////////////////////////
// DNS ZONE RECORD SCHEMA
/////////////////////////////////////////

export const DnsZoneRecordSchema = z.object({
  rrType: DnsRrTypeSchema,
  id: z.string(),
  tenantId: z.string(),
  zoneId: z.string(),
  name: z.string(),
  ttl: z.number().int().nullable(),
  rdata: z.string().array(),
  setIdentifier: z.string(),
  isAlias: z.boolean(),
  isProxied: z.boolean(),
  providerRecordId: z.string().nullable(),
  lastSeenAt: z.coerce.date(),
  deprovisionedAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type DnsZoneRecord = z.infer<typeof DnsZoneRecordSchema>

export default DnsZoneRecordSchema;
